import Box from '@mui/material/Box';

/** The small coloured dot for a report's asset class (FX blue, Rates green, Credit orange and so on). */
export function AssetDot({ assetClass, size = 6 }: { assetClass: string; size?: number }) {
  return (
    <Box
      component="span"
      aria-hidden
      sx={(t) => ({ width: size, height: size, borderRadius: '50%', flexShrink: 0, bgcolor: t.palette.assetDot[assetClass] ?? t.palette.text.disabled })}
    />
  );
}
